import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ApiResponseValue, ApiResponse } from '@/types/validateContainerBlType';

export type Validated = {
  oidVisita: number;
  fecha: string;
};

export const getValidatedContainerBooking = async (
  query: Validated
): Promise<ApiResponseValue> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.ValidateContainerBooking,
      {
        ...query,
        soloEntregaLlenoExportador: true,
      }
    );

    const { value } = res?.data || {};

    const response: ApiResponseValue =
      typeof value === 'string' && value
        ? {
            ok: false,
            mensaje: value,
            okSpecified: false,
          }
        : value;

    return response;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
